'use client';

import React, { useState, useEffect, useRef } from 'react';

// ─── TYPES ────────────────────────────────────────────────────────────────────

interface LetterSection {
  id: string;
  sectionAnchor: string;
  num: number;
  label: string;
  arabic: string;
  theme: 'ayat' | 'khalifa' | 'mizan' | 'haal' | 'mata' | 'islah' | 'yaqeen';
}

// ─── ALL 41 SECTIONS — matched exactly to LetterReconstructionScaffold titles ──

const LETTER_SECTIONS: LetterSection[] = [
  { id: 'section-1',  sectionAnchor: 'letter-section-1',  num: 1,  label: 'The Occurrence',              arabic: 'الْحُدُوث',                    theme: 'ayat' },
  { id: 'section-2',  sectionAnchor: 'letter-section-2',  num: 2,  label: 'Caretaker',                   arabic: 'الْخَلِيفَة',                  theme: 'khalifa' },
  { id: 'section-3',  sectionAnchor: 'letter-section-3',  num: 3,  label: 'The Mural',                   arabic: 'الْجِدَارِيَّة',               theme: 'ayat' },
  { id: 'section-4',  sectionAnchor: 'letter-section-4',  num: 4,  label: "ROOTS Ma'rifah",              arabic: 'جُذُور الْمَعْرِفَة',          theme: 'ayat' },
  { id: 'section-5',  sectionAnchor: 'letter-section-5',  num: 5,  label: 'Al-Qadir',                    arabic: 'الْقَادِر',                    theme: 'ayat' },
  { id: 'section-6',  sectionAnchor: 'letter-section-6',  num: 6,  label: 'Aql',                         arabic: 'الْعَقْل',                     theme: 'ayat' },
  { id: 'section-7',  sectionAnchor: 'letter-section-7',  num: 7,  label: 'Ilm',                         arabic: 'الْعِلْم',                     theme: 'ayat' },
  { id: 'section-8',  sectionAnchor: 'letter-section-8',  num: 8,  label: 'Entering the Haal Platform',  arabic: 'الدُّخُول',                    theme: 'haal' },
  { id: 'section-9',  sectionAnchor: 'letter-section-9',  num: 9,  label: 'Mend',                        arabic: 'الْإِصْلَاح',                  theme: 'islah' },
  { id: 'section-10', sectionAnchor: 'letter-section-10', num: 10, label: 'Compassion',                  arabic: 'الرَّحْمَة',                   theme: 'ayat' },
  { id: 'section-11', sectionAnchor: 'letter-section-11', num: 11, label: 'Al-Qadir (The All-Powerful)', arabic: 'الْقُدْرَة',                   theme: 'ayat' },
  { id: 'section-12', sectionAnchor: 'letter-section-12', num: 12, label: 'Aql (Intellect)',             arabic: 'الْعَقْل',                     theme: 'ayat' },
  { id: 'section-13', sectionAnchor: 'letter-section-13', num: 13, label: 'Trust & Belief',              arabic: 'الثِّقَة وَالْإِيمَان',        theme: 'khalifa' },
  { id: 'section-14', sectionAnchor: 'letter-section-14', num: 14, label: 'Haqq; Truth, Right, Reality', arabic: 'الْحَقّ',                      theme: 'mizan' },
  { id: 'section-15', sectionAnchor: 'letter-section-15', num: 15, label: 'Purposeful Reality',          arabic: 'الْوَاقِع الْهَادِف',          theme: 'mizan' },
  { id: 'section-16', sectionAnchor: 'letter-section-16', num: 16, label: 'TRUNK Fahm',                  arabic: 'جِذْع الْفَهْم',               theme: 'ayat' },
  { id: 'section-17', sectionAnchor: 'letter-section-17', num: 17, label: 'Al-Khaliq',                   arabic: 'الْخَالِق',                    theme: 'ayat' },
  { id: 'section-18', sectionAnchor: 'letter-section-18', num: 18, label: 'Al-Khabir',                   arabic: 'الْخَبِير',                    theme: 'ayat' },
  { id: 'section-19', sectionAnchor: 'letter-section-19', num: 19, label: 'Examination',                 arabic: 'الْفَحْص',                     theme: 'yaqeen' },
  { id: 'section-20', sectionAnchor: 'letter-section-20', num: 20, label: 'Entering the Haal Platform',  arabic: 'الدُّخُول إِلَى الْمِنَصَّة', theme: 'haal' },
  { id: 'section-21', sectionAnchor: 'letter-section-21', num: 21, label: 'The Inner Reality Lens',      arabic: 'عَدْسَة الْوَاقِع الدَّاخِلِي', theme: 'haal' },
  { id: 'section-22', sectionAnchor: 'letter-section-22', num: 22, label: 'Mata — Utensil',              arabic: 'مَتَاع',                       theme: 'mata' },
  { id: 'section-23', sectionAnchor: 'letter-section-23', num: 23, label: 'Haal',                        arabic: 'الْحَال',                      theme: 'haal' },
  { id: 'section-24', sectionAnchor: 'letter-section-24', num: 24, label: 'Blessing',                    arabic: 'الْبَرَكَة',                   theme: 'khalifa' },
  { id: 'section-25', sectionAnchor: 'letter-section-25', num: 25, label: 'Reshat Al-Taqwah',            arabic: 'رِشَة التَّقْوَى',             theme: 'yaqeen' },
  { id: 'section-26', sectionAnchor: 'letter-section-26', num: 26, label: 'Trip',                        arabic: 'الرِّحْلَة',                   theme: 'haal' },
  { id: 'section-27', sectionAnchor: 'letter-section-27', num: 27, label: 'Singularity',                 arabic: 'الْوَحْدَانِيَّة',             theme: 'ayat' },
  { id: 'section-28', sectionAnchor: 'letter-section-28', num: 28, label: 'Sound',                       arabic: 'الصَّوْت',                     theme: 'ayat' },
  { id: 'section-29', sectionAnchor: 'letter-section-29', num: 29, label: 'Dominion',                    arabic: 'الْمُلْك',                     theme: 'mizan' },
  { id: 'section-30', sectionAnchor: 'letter-section-30', num: 30, label: 'Test',                        arabic: 'الِابْتِلَاء',                 theme: 'khalifa' },
  { id: 'section-31', sectionAnchor: 'letter-section-31', num: 31, label: 'Striving to Submission',      arabic: 'السَّعْي إِلَى الِاسْتِسْلَام', theme: 'islah' },
  { id: 'section-32', sectionAnchor: 'letter-section-32', num: 32, label: 'Re-Assembly',                 arabic: 'إِعَادَة التَّجْمِيع',         theme: 'islah' },
  { id: 'section-33', sectionAnchor: 'letter-section-33', num: 33, label: 'Opening',                     arabic: 'الْفَتْح',                     theme: 'yaqeen' },
  { id: 'section-34', sectionAnchor: 'letter-section-34', num: 34, label: 'Re-Introduction',             arabic: 'إِعَادَة التَّعْرِيف',         theme: 'khalifa' },
  { id: 'section-35', sectionAnchor: 'letter-section-35', num: 35, label: 'Yaqeen',                      arabic: 'الْيَقِين',                    theme: 'yaqeen' },
  { id: 'section-36', sectionAnchor: 'letter-section-36', num: 36, label: 'Universal Submission',        arabic: 'الِاسْتِسْلَام الْكُوْنِي',    theme: 'khalifa' },
  { id: 'section-37', sectionAnchor: 'letter-section-37', num: 37, label: 'Sacred Language',             arabic: 'اللُّغَة الْمُقَدَّسَة',       theme: 'mata' },
  { id: 'section-38', sectionAnchor: 'letter-section-38', num: 38, label: 'Reminder',                    arabic: 'التَّذْكِير',                  theme: 'islah' },
  { id: 'section-39', sectionAnchor: 'letter-section-39', num: 39, label: 'Steppin',                     arabic: 'الْخُطْوَة',                   theme: 'islah' },
  { id: 'section-40', sectionAnchor: 'letter-section-40', num: 40, label: 'Branding, Free Write',        arabic: 'الْعَلَامَة التِّجَارِيَّة',   theme: 'yaqeen' },
  { id: 'section-41', sectionAnchor: 'letter-section-41', num: 41, label: 'The Haal Project',            arabic: 'مَشْرُوع الْحَال',             theme: 'haal' },
];

const THEME_COLORS: Record<string, string> = {
  ayat:    '#c9a84c',
  khalifa: '#2d8a87',
  mizan:   '#8a8ab8',
  haal:    '#d4a84c',
  mata:    '#7a9a6a',
  islah:   '#2d7a47',
  yaqeen:  '#a87a4c',
};

// ─── MAIN SIDEBAR ─────────────────────────────────────────────────────────────

export default function Plot3SidebarTrail() {
  const [activeSectionId, setActiveSectionId] = useState<string>('section-1');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const circlesContainerRef = useRef<HTMLDivElement>(null);

  // ── Scroll observation ────────────────────────────────────────────────────
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleIntersect = (entries: IntersectionObserverEntry[]) => {
      // Find the topmost visible section
      const visible = entries
        .filter(e => e.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible.length > 0) {
        const matched = LETTER_SECTIONS.find(s => s.sectionAnchor === visible[0].target.id);
        if (matched) setActiveSectionId(matched.id);
      }
    };

    observerRef.current = new IntersectionObserver(handleIntersect, {
      rootMargin: '-10% 0px -70% 0px',
      threshold: 0,
    });

    LETTER_SECTIONS.forEach(s => {
      const el = document.getElementById(s.sectionAnchor);
      if (el) observerRef.current?.observe(el);
    });

    return () => observerRef.current?.disconnect();
  }, []);

  // ── Close dropdown on outside click ──────────────────────────────────────
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  // ── Scroll active circle into view ────────────────────────────────────────
  useEffect(() => {
    if (!circlesContainerRef.current) return;
    const activeIdx = LETTER_SECTIONS.findIndex(s => s.id === activeSectionId);
    if (activeIdx < 0) return;
    const circles = circlesContainerRef.current.querySelectorAll('[data-circle]');
    const activeCircle = circles[activeIdx] as HTMLElement;
    if (activeCircle) {
      activeCircle.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }, [activeSectionId]);

  const activeSection = LETTER_SECTIONS.find(s => s.id === activeSectionId) || LETTER_SECTIONS[0];
  const activeColor = THEME_COLORS[activeSection.theme];
  const activeIdx = LETTER_SECTIONS.findIndex(s => s.id === activeSectionId);

  function navigateTo(section: LetterSection) {
    const el = document.getElementById(section.sectionAnchor);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setDropdownOpen(false);
  }

  // ── Collapsed button ──────────────────────────────────────────────────────
  if (!sidebarOpen) {
    return (
      <button
        onClick={() => setSidebarOpen(true)}
        style={{
          position: 'fixed',
          right: 16,
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 50,
          background: 'rgba(6,13,18,0.97)',
          border: '1px solid rgba(201,168,76,0.25)',
          borderRadius: 6,
          padding: '14px 8px',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 6,
        }}
        title="Open Sections"
      >
        <span style={{ fontSize: 14, color: '#c9a84c' }}>◈</span>
        <span style={{
          fontFamily: 'monospace', fontSize: 7, color: 'rgba(201,168,76,0.6)',
          letterSpacing: '.1em', writingMode: 'vertical-rl', textTransform: 'uppercase',
        }}>Sections</span>
        <span style={{ fontFamily: 'monospace', fontSize: 8, color: 'rgba(201,168,76,0.5)' }}>
          {activeSection.num}/41
        </span>
      </button>
    );
  }

  return (
    <div
      style={{
        position: 'fixed',
        right: 0,
        top: 0,
        bottom: 0,
        width: 240,
        zIndex: 45,
        background: 'rgba(4,10,15,0.97)',
        borderLeft: '1px solid rgba(201,168,76,0.12)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backdropFilter: 'blur(16px)',
      }}
    >
      {/* ── Header ─────────────────────────────────────────────────────────── */}
      <div style={{
        padding: '14px 12px 10px',
        borderBottom: '1px solid rgba(201,168,76,0.1)',
        flexShrink: 0,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
          <div>
            <div style={{ fontFamily: 'monospace', fontSize: 7, letterSpacing: '.15em', textTransform: 'uppercase', color: 'rgba(201,168,76,0.45)', marginBottom: 2 }}>
              ✦ Open Letter Sections
            </div>
            <div style={{ fontFamily: "'Amiri', serif", fontSize: 12, color: '#d4c5a9' }}>
              41 Sections · Caretaker's Journey
            </div>
          </div>
          <button
            onClick={() => setSidebarOpen(false)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(212,197,169,0.3)', fontSize: 16, padding: 4, lineHeight: 1 }}
            title="Close sidebar"
          >
            ✕
          </button>
        </div>

        {/* Active section indicator */}
        <div style={{
          background: `rgba(${activeColor === '#c9a84c' ? '201,168,76' : activeColor === '#2d8a87' ? '45,138,135' : '45,122,71'},0.07)`,
          border: `1px solid ${activeColor}33`,
          borderLeft: `3px solid ${activeColor}`,
          borderRadius: 4,
          padding: '7px 10px',
        }}>
          <div style={{ fontFamily: 'monospace', fontSize: 7, color: `${activeColor}99`, letterSpacing: '.1em', textTransform: 'uppercase', marginBottom: 2 }}>
            Section {activeSection.num} of 41
          </div>
          <div style={{ fontFamily: 'monospace', fontSize: 9, color: 'rgba(212,197,169,0.8)', lineHeight: 1.4, marginBottom: 2 }}>
            {activeSection.label}
          </div>
          <div style={{ fontFamily: "'Amiri', serif", fontSize: 11, color: `${activeColor}77`, direction: 'rtl' }}>
            {activeSection.arabic}
          </div>
        </div>
      </div>

      {/* ── Sections Dropdown ──────────────────────────────────────────────── */}
      <div ref={dropdownRef} style={{ padding: '8px 12px', borderBottom: '1px solid rgba(201,168,76,0.08)', flexShrink: 0, position: 'relative' }}>
        <button
          onClick={() => setDropdownOpen(v => !v)}
          style={{
            width: '100%',
            background: dropdownOpen ? 'rgba(201,168,76,0.08)' : 'rgba(201,168,76,0.03)',
            border: `1px solid ${dropdownOpen ? 'rgba(201,168,76,0.3)' : 'rgba(201,168,76,0.12)'}`,
            borderRadius: 5,
            padding: '7px 10px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            transition: 'all 0.15s',
          }}
        >
          <span style={{ fontFamily: 'monospace', fontSize: 8, letterSpacing: '.1em', textTransform: 'uppercase', color: 'rgba(201,168,76,0.7)' }}>
            ☰ Navigate Sections
          </span>
          <span style={{ fontSize: 8, color: 'rgba(201,168,76,0.5)', transition: 'transform 0.2s', display: 'inline-block', transform: dropdownOpen ? 'rotate(180deg)' : 'none' }}>▼</span>
        </button>

        {dropdownOpen && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 8,
            right: 8,
            zIndex: 60,
            background: 'rgba(4,10,15,0.99)',
            border: '1px solid rgba(201,168,76,0.2)',
            borderRadius: 6,
            maxHeight: 320,
            overflowY: 'auto',
            boxShadow: '0 8px 32px rgba(0,0,0,0.6)',
          }}>
            {LETTER_SECTIONS.map((section) => {
              const isActive = section.id === activeSectionId;
              const color = THEME_COLORS[section.theme];
              return (
                <button
                  key={section.id}
                  onClick={() => navigateTo(section)}
                  style={{
                    width: '100%',
                    background: isActive ? `${color}12` : 'transparent',
                    border: 'none',
                    borderBottom: '1px solid rgba(201,168,76,0.05)',
                    padding: '8px 12px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    textAlign: 'left',
                    transition: 'background 0.1s',
                  }}
                  onMouseEnter={e => { if (!isActive) (e.currentTarget as HTMLElement).style.background = 'rgba(201,168,76,0.04)'; }}
                  onMouseLeave={e => { if (!isActive) (e.currentTarget as HTMLElement).style.background = 'transparent'; }}
                >
                  {/* Circle indicator */}
                  <div style={{
                    width: 18,
                    height: 18,
                    borderRadius: '50%',
                    background: isActive ? `${color}25` : 'transparent',
                    border: `1.5px solid ${isActive ? color : isPast ? `${color}55` : 'rgba(201,168,76,0.15)'}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    transition: 'all 0.15s',
                  }}>
                    <span style={{ fontFamily: 'monospace', fontSize: 6, color: isActive ? color : `${color}88`, fontWeight: 700 }}>
                      {section.num}
                    </span>
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontFamily: 'monospace', fontSize: 8, color: isActive ? '#d4c5a9' : 'rgba(212,197,169,0.55)', letterSpacing: '.04em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {section.label}
                    </div>
                  </div>
                  <div style={{ fontFamily: "'Amiri', serif", fontSize: 9, color: `${color}66`, direction: 'rtl', flexShrink: 0 }}>
                    {section.arabic}
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>

      {/* ── Progress circles (41 dots) ─────────────────────────────────────── */}
      <div
        ref={circlesContainerRef}
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '10px 12px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: 0,
        }}
      >
        <div style={{ fontFamily: 'monospace', fontSize: 7, letterSpacing: '.12em', textTransform: 'uppercase', color: 'rgba(201,168,76,0.3)', marginBottom: 8 }}>
          Progress · {activeIdx + 1}/41
        </div>

        {/* Progress bar */}
        <div style={{ height: 2, background: 'rgba(201,168,76,0.08)', borderRadius: 2, marginBottom: 12, overflow: 'hidden' }}>
          <div style={{
            height: '100%',
            width: `${((activeIdx + 1) / 41) * 100}%`,
            background: 'linear-gradient(90deg, rgba(201,168,76,0.4), rgba(201,168,76,0.8))',
            borderRadius: 2,
            transition: 'width 0.4s ease',
          }} />
        </div>

        {/* Section circles grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 6 }}>
          {LETTER_SECTIONS.map((section, idx) => {
            const isActive = section.id === activeSectionId;
            const isPast = idx < activeIdx;
            const color = THEME_COLORS[section.theme];

            return (
              <button
                key={section.id}
                data-circle="true"
                onClick={() => navigateTo(section)}
                title={`${section.num}. ${section.label}`}
                style={{
                  width: '100%',
                  aspectRatio: '1',
                  borderRadius: '50%',
                  border: `1.5px solid ${isActive ? color : isPast ? `${color}55` : 'rgba(201,168,76,0.15)'}`,
                  background: isActive
                    ? `${color}25`
                    : isPast
                    ? `${color}0d`
                    : 'transparent',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s',
                  position: 'relative',
                  padding: 0,
                  // Glow effect for active
                  boxShadow: isActive ? `0 0 8px ${color}44` : 'none',
                }}
                onMouseEnter={e => {
                  if (!isActive) {
                    (e.currentTarget as HTMLElement).style.background = `${color}18`;
                    (e.currentTarget as HTMLElement).style.borderColor = `${color}88`;
                  }
                }}
                onMouseLeave={e => {
                  if (!isActive) {
                    (e.currentTarget as HTMLElement).style.background = isPast ? `${color}0d` : 'transparent';
                    (e.currentTarget as HTMLElement).style.borderColor = isPast ? `${color}55` : 'rgba(201,168,76,0.15)';
                  }
                }}
              >
                <span style={{
                  fontFamily: 'monospace',
                  fontSize: 7,
                  fontWeight: isActive ? 700 : 400,
                  color: isActive ? color : isPast ? `${color}99` : 'rgba(201,168,76,0.3)',
                  lineHeight: 1,
                }}>
                  {section.num}
                </span>
                {/* Active pulse ring */}
                {isActive && (
                  <span style={{
                    position: 'absolute',
                    inset: -3,
                    borderRadius: '50%',
                    border: `1px solid ${color}44`,
                    animation: 'pulse-ring 2s ease-in-out infinite',
                    pointerEvents: 'none',
                  }} />
                )}
              </button>
            );
          })}
        </div>

        {/* Theme legend */}
        <div style={{ marginTop: 16, borderTop: '1px solid rgba(201,168,76,0.08)', paddingTop: 12 }}>
          <div style={{ fontFamily: 'monospace', fontSize: 7, letterSpacing: '.1em', textTransform: 'uppercase', color: 'rgba(201,168,76,0.3)', marginBottom: 8 }}>
            Theme Key
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {Object.entries(THEME_COLORS).map(([theme, color]) => (
              <div key={theme} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 }} />
                <span style={{ fontFamily: 'monospace', fontSize: 7, color: 'rgba(212,197,169,0.45)', letterSpacing: '.06em', textTransform: 'capitalize' }}>
                  {theme}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Footer ─────────────────────────────────────────────────────────── */}
      <div style={{
        padding: '10px 12px',
        borderTop: '1px solid rgba(201,168,76,0.1)',
        flexShrink: 0,
        textAlign: 'center',
      }}>
        <div style={{ fontFamily: "'Amiri', serif", fontSize: 11, color: 'rgba(201,168,76,0.4)', direction: 'rtl', marginBottom: 3 }}>
          سَنُرِيهِمْ آيَاتِنَا فِي الْآفَاقِ وَفِي أَنفُسِهِمْ
        </div>
        <div style={{ fontFamily: 'monospace', fontSize: 7, color: 'rgba(212,197,169,0.25)', letterSpacing: '.06em' }}>
          "We will show them Our Signs in the horizons and in themselves" — 41:53
        </div>
      </div>

      <style>{`
        @keyframes pulse-ring {
          0%, 100% { opacity: 0.6; transform: scale(1); }
          50% { opacity: 0.2; transform: scale(1.15); }
        }
      `}</style>
    </div>
  );
}
